module.exports = {"pathContext":{"name":"ApproveCubexTreatmentInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-approve-cubex-treatment-input.json
// module id = 1356
// module chunks = 279680426466721